import { render } from "./add-sales.vue?vue&type=template&id=60abe7c8&scoped=true"
import script from "./add-sales.vue?vue&type=script&lang=js"
export * from "./add-sales.vue?vue&type=script&lang=js"

import "./add-sales.vue?vue&type=style&index=0&id=60abe7c8&scoped=true&lang=css"

import exportComponent from "C:\\GigLabs\\CIMS\\CIMS-AfyunProd\\gig.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60abe7c8"]])

export default __exports__